/**
 * UAs that render page JS (so they'd otherwise trigger Ahrefs' native "pageview" beacon and our
 * own sendEvent calls) but aren't real visitors. See [[jobcrawls-waf-bot-crawler-rules]]:
 * Bytespider (ByteDance's crawler) is rate-limited at the WAF edge, not blocked outright, so
 * requests under that limit still reach origin and can execute JS: this keeps them out of
 * Ahrefs Web Analytics on top of that.
 */
export const AHREFS_EXCLUDED_BOT_UA_SUBSTRINGS = ['bytespider'] as const;

export function isAhrefsExcludedBotUserAgent(userAgent: string | null | undefined): boolean {
  if (!userAgent) return false;
  const normalized = userAgent.toLowerCase();
  return AHREFS_EXCLUDED_BOT_UA_SUBSTRINGS.some((s) => normalized.includes(s));
}
